module.exports = __webpack_public_path__ + "assets/cf8c11381299410b9882d28d902ec29f.png";